import { Chip, ColorsV2, Text, useThemeColors } from '@electricjs/arc';

type StatusChipProps = {
  id: string;
  text: string;
  variant: 'success' | 'warning' | 'error';
};

export const StatusChip = ({ id, text, variant }: StatusChipProps) => {
  const [
    successColorBg,
    successColorText,
    errorColorBg,
    errorColorText,
    warningColorBg,
    warningColorText,
  ] = useThemeColors([
    ColorsV2.SUCCESS_LIGHTEST,
    ColorsV2.SUCCESS_DARKEST,
    ColorsV2.ERROR_LIGHTEST,
    ColorsV2.ERROR_DARK,
    ColorsV2.WARNING_LIGHTEST,
    ColorsV2.WARNING_DARKEST,
  ]);

  switch (variant) {
    case 'success':
      return (
        <Chip
          id={id}
          backgroundColor={successColorBg}
          variant="small"
          icon="check-circle"
          textColor={successColorText}>
          <Text variant="legal" fontWeight="500" color={successColorText}>
            {text}
          </Text>
        </Chip>
      );
    case 'warning':
      return (
        <Chip
          id={id}
          backgroundColor={warningColorBg}
          variant="small"
          icon="alert-triangle"
          textColor={warningColorText}>
          <Text variant="legal" fontWeight="500" color={warningColorText}>
            {text}
          </Text>
        </Chip>
      );
    case 'error':
      return (
        <Chip
          id={id}
          backgroundColor={errorColorBg}
          variant="small"
          icon="alert-circle"
          textColor={errorColorText}>
          <Text variant="legal" fontWeight="500" color={errorColorText}>
            {text}
          </Text>
        </Chip>
      );
  }
};
